import styled from 'styled-components';
import { Row } from 'react-bootstrap';
import { COLORS } from 'modules/core/theme/colors';
import { Label } from 'modules/core/components';
import { FONT_SIZE } from 'modules/core/theme/fontSize';
import { disabledSectionMixin } from 'modules/core/theme/mixins';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

import { CreditScoreColors } from '../enums/creditScoreColors.enum';
import { CreditScoreColor } from '../types';

type ColoredDiv = { color: CreditScoreColor };

const SLIDER_HEIGHT = 20;
const SLIDER_LINE_SIZE = 28;
const BOX_SHADOW = '0 2px 6px -8px #000, 0 0 39px -2px rgba(204, 204, 204, 0.23)';

const mapTrackStyleByColor = {
  [CreditScoreColors.DEFAULT]: COLORS.GREEN_8,
  [CreditScoreColors.GREY]: COLORS.GREY_19,
  [CreditScoreColors.GREEN]: COLORS.GREEN_8,
  [CreditScoreColors.ORANGE]: COLORS.ORANGE_3,
  [CreditScoreColors.YELLOW]: COLORS.ORANGE_3,
  [CreditScoreColors.RED]: COLORS.RED_7,
};

const mapTitleColorByCreditScore = {
  [CreditScoreColors.DEFAULT]: COLORS.GREEN_8,
  [CreditScoreColors.GREY]: COLORS.GREY_8,
  [CreditScoreColors.GREEN]: COLORS.GREEN_8,
  [CreditScoreColors.ORANGE]: COLORS.ORANGE_3,
  [CreditScoreColors.YELLOW]: COLORS.ORANGE_3,
  [CreditScoreColors.RED]: COLORS.RED_7,
};

export const mapTooltipColorByCreditScore = {
  ...mapTitleColorByCreditScore,
  [CreditScoreColors.GREY]: COLORS.GREY_20,
};

export const mapRadioIncomeBackgroundColor = {
  ...mapTrackStyleByColor,
  [CreditScoreColors.GREEN]: COLORS.GREEN_15,
  [CreditScoreColors.ORANGE]: COLORS.ORANGE_4,
  [CreditScoreColors.YELLOW]: COLORS.ORANGE_4,
  [CreditScoreColors.RED]: COLORS.RED_9,
};

export const mapRadioIncomeColorByCreditScore = {
  ...mapTitleColorByCreditScore,
};

export const railStyles = {
  backgroundColor: COLORS.WHITE_8,
  height: SLIDER_HEIGHT,
  boxShadow: BOX_SHADOW,
};

export const getTrackStyles = (color: CreditScoreColor): { backgroundColor: string; height: number } => {
  const backgroundColor = mapTrackStyleByColor[color];

  return { ...railStyles, backgroundColor };
};

export const getMarksStyles = (label: string): Record<string, unknown> => ({
  style: {
    marginTop: 15,
    fontSize: FONT_SIZE.MINI,
    minWidth: 60,
    color: COLORS.GREY_8,
  },
  label,
});

export const sliderStyles = {
  borderColor: COLORS.GREY_29,
  backgroundColor: COLORS.GREY_29,
  height: SLIDER_LINE_SIZE,
  width: SLIDER_LINE_SIZE,
  boxShadow: BOX_SHADOW,
};

export const tipProps = {
  placement: 'top',
  prefixCls: 'rc-slider-tooltip',
  visible: true,
};

export const MonthlyPaymentSliderWrapper = styled(Row)<{ disabled?: boolean }>`
  width: 100%;
  margin: 2px 0;
  background-color: ${({ theme: { colors } }) => colors['white-2']};
  justify-content: space-between;
  align-items: center;
  padding: 6px 30px;
  border-radius: 5px;
  border: 1px solid ${COLORS.GREY_3};

  ${({ disabled }) => disabled && disabledSectionMixin}

  @media (max-width: ${WindowBreakpoints.large}px) {
    flex-direction: column;
    height: auto;
  }

  @media (max-width: ${WindowBreakpoints.small}px) {
    padding: 15px 20px;
  }

  .rc-slider-tooltip-arrow,
  .rc-slider-dot {
    display: none;
  }

  .rc-slider-tooltip-inner {
    background: none;
    box-shadow: none;
  }
`;

export const SliderLabel = styled(Label)`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
  color: ${COLORS.BLACK};
  font-weight: ${({ theme: { boldText } }) => boldText.bold};
`;

export const PaymentRation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 10px;
`;

export const IncomeRation = styled.span`
  font-weight: ${({ theme: { boldText } }) => boldText.bold};
  font-size: ${({ theme: { fontSize } }) => fontSize.m};
  color: ${({ theme: { colors } }) => colors['grey-8']};
`;

export const RatioPercent = styled.div<ColoredDiv>`
  margin-left: 10px;
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  background-color: ${({ color }) => mapRadioIncomeBackgroundColor[color]};
  color: ${({ color }) => mapRadioIncomeColorByCreditScore[color]};
  border-radius: 4px;
  padding: 0 15px;
`;

export const MonthlyPaymentTooltipText = styled.div<ColoredDiv>`
  font-size: ${({ theme: { fontSize } }) => fontSize.huge};
  min-width: 200px;
  font-weight: ${({ theme: { boldText } }) => boldText.bold};
  background: none;
  color: ${({ color }) => mapTooltipColorByCreditScore[color]};
`;
